/* ZINKE Edition 3.2 „Verweildauer“ — 19.09.2026
   1. Sanftes Einblenden beim Scrollen
   2. Punkte beim Wischen durch Kachelbilder
   3. Zuletzt angesehen (Speicher im Browser des Besuchers)
   4. Geschenkfinder
   5. Größenhilfe (Dialog)
   6. Bilder weich einblenden (4.0)
   Keine Abhängigkeiten, jede Funktion fängt ihre eigenen Fehler ab. */
(function () {
  'use strict';

  var ruhig = false;
  try {
    ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      document.body.classList.contains('motion-off');
  } catch (e) {}

  /* ---------- 1. Einblenden ---------- */
  function einblenden() {
    if (ruhig || !('IntersectionObserver' in window)) return;
    var auswahl = [
      'main .section-heading',
      'main .product-grid > .product-card',
      'main .product-grid > .z-finder-treffer',
      'main .sortiment-row',
      'main .story',
      'main .ueber-mich',
      'main .z-schritte li',
      'main .z-szene-inner',
      'main .z-faq',
      'main .crosssell-karte',
      'main .product-accordion'
    ].join(',');
    var knoten = document.querySelectorAll(auswahl);
    var hoehe = window.innerHeight || 700;
    var beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('ist-da');
          beobachter.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px 18% 0px', threshold: 0 }); /* 4.7: früher einblenden (Pascal: „zu spät“) */
    var nr = 0;
    Array.prototype.forEach.call(knoten, function (el) {
      if (el.closest('[data-product-info]')) return; /* Kaufbereich wird bei Variantenwechsel ersetzt */
      var r = el.getBoundingClientRect();
      if (r.top < hoehe * 0.98) return; /* was schon sichtbar ist, bleibt ruhig */
      el.classList.add('z-einblenden');
      /* Kacheln in einer Reihe leicht versetzt */
      if (el.classList.contains('product-card') || el.classList.contains('z-finder-treffer')) {
        el.style.transitionDelay = (nr++ % 4) * 70 + 'ms';
      }
      beobachter.observe(el);
    });
  }

  /* ---------- 2. Punkte in der Kachel ---------- */
  function punkteBeimWischen() {
    document.addEventListener('scroll', function (ev) {
      var t = ev.target;
      if (!t || !t.classList || !t.classList.contains('product-card-media')) return;
      var karte = t.closest('.product-card');
      if (!karte) return;
      var punkte = karte.querySelectorAll('.z-punkte i');
      if (!punkte.length) return;
      var i = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
      Array.prototype.forEach.call(punkte, function (p, n) { p.classList.toggle('ist-aktiv', n === i); });
    }, true);
  }

  /* ---------- 3. Zuletzt angesehen ---------- */
  var SPEICHER = 'zinke_gesehen';
  function lesen() {
    try { var w = JSON.parse(localStorage.getItem(SPEICHER) || '[]'); return Array.isArray(w) ? w : []; }
    catch (e) { return []; }
  }
  function schreiben(liste) {
    try { localStorage.setItem(SPEICHER, JSON.stringify(liste.slice(0, 10))); } catch (e) {}
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function zuletzt() {
    var daten = document.querySelector('script[data-zinke-gesehen]');
    if (daten) {
      try {
        var p = JSON.parse(daten.textContent);
        if (p && p.h) {
          var liste = lesen().filter(function (x) { return x && x.h !== p.h; });
          liste.unshift(p);
          schreiben(liste);
        }
      } catch (e) {}
    }
    Array.prototype.forEach.call(document.querySelectorAll('[data-z-zuletzt]'), function (sek) {
      var aktuell = sek.getAttribute('data-aktuell') || '';
      var min = parseInt(sek.getAttribute('data-min'), 10) || 1;
      var spur = sek.querySelector('[data-z-zuletzt-spur]');
      var eintraege = lesen().filter(function (x) { return x && x.h && x.h !== aktuell && x.u; }).slice(0, 8);
      if (!spur || eintraege.length < min) return;
      spur.innerHTML = eintraege.map(function (x) {
        var bild = x.i ? '<img src="' + esc(x.i) + '" alt="' + esc(x.a || x.t) + '" loading="lazy" width="540" height="540">' : '';
        return '<article class="product-card" role="listitem">' +
          '<a class="product-card-media" href="' + esc(x.u) + '" tabindex="-1" aria-hidden="true">' + bild + '</a>' +
          '<div class="product-card-caption"><h3 class="product-card-title"><a href="' + esc(x.u) + '">' + esc(x.t) + '</a></h3>' +
          '<div class="product-card-price">' + esc(x.p) + '</div>' +
          (x.y ? '<p class="product-card-subtitle">' + esc(x.y) + '</p>' : '') + '</div></article>';
      }).join('');
      sek.hidden = false;
    });
  }

  /* ---------- 4. Geschenkfinder ---------- */
  function finder() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-z-finder]'), function (sek) {
      var ergebnis = sek.querySelector('[data-z-finder-ergebnis]');
      var leer = sek.querySelector('[data-z-finder-leer]');
      var treffer = Array.prototype.slice.call(sek.querySelectorAll('.z-finder-treffer'));
      var anzahl = parseInt(sek.getAttribute('data-z-anzahl'), 10) || 8;
      var ersterChip = sek.querySelector('[data-z-fuer]');
      var fuer = ersterChip ? ersterChip.getAttribute('data-z-fuer') : '';
      var budget = 0, bMin = 0, bMax = 0; /* 4.7: Spannen „40–80“ über data-z-min/-max */

      /* data-fuer = "blockA:3 blockB:1" → Position je Empfänger */
      function position(t) {
        var teile = (t.getAttribute('data-fuer') || '').split(' ');
        for (var i = 0; i < teile.length; i++) {
          var kv = teile[i].split(':');
          if (kv[0] === fuer) return parseInt(kv[1], 10) || 999;
        }
        return -1;
      }
      function anwenden(neu) {
        var n = 0;
        var liste = treffer.map(function (t, i) { return { t: t, pos: position(t), i: i }; });
        liste.sort(function (a, b) { return (a.pos - b.pos) || (a.i - b.i); });
        liste.forEach(function (e) {
          var preis = parseInt(e.t.getAttribute('data-preis'), 10) || 0;
          var passt = e.pos !== -1 && (budget === 0 || preis <= budget) && (bMin === 0 || preis > bMin) && (bMax === 0 || preis <= bMax);
          if (passt && n < anzahl) { e.t.hidden = false; n++; } else { e.t.hidden = true; }
          if (ergebnis) ergebnis.appendChild(e.t);
        });
        if (leer) leer.hidden = n > 0;
        if (neu && ergebnis && !ruhig) {
          ergebnis.classList.remove('ist-neu');
          void ergebnis.offsetWidth;
          ergebnis.classList.add('ist-neu');
        }
      }

      sek.addEventListener('click', function (ev) {
        var chip = ev.target.closest('.z-chip');
        if (!chip || !sek.contains(chip)) return;
        var gruppe = chip.parentElement;
        Array.prototype.forEach.call(gruppe.querySelectorAll('.z-chip'), function (c) {
          c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
        });
        if (chip.hasAttribute('data-z-fuer')) fuer = chip.getAttribute('data-z-fuer');
        if (chip.hasAttribute('data-z-budget')) budget = parseInt(chip.getAttribute('data-z-budget'), 10) || 0;
        if (chip.hasAttribute('data-z-min') || chip.hasAttribute('data-z-max')) { budget = 0; bMin = parseInt(chip.getAttribute('data-z-min'), 10) || 0; bMax = parseInt(chip.getAttribute('data-z-max'), 10) || 0; }
        else if (chip.hasAttribute('data-z-budget')) { bMin = 0; bMax = 0; }
        anwenden(true);
      });
      anwenden(false);
    });
  }

  /* ---------- 5. Größenhilfe ---------- */
  function groessen() {
    document.addEventListener('click', function (ev) {
      var auf = ev.target.closest('[data-z-groesse-auf]');
      if (auf) {
        var d = auf.nextElementSibling;
        if (d && d.matches('[data-z-groesse]')) {
          if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
        }
        return;
      }
      var zu = ev.target.closest('[data-z-groesse-zu]');
      if (zu) { var dz = zu.closest('dialog'); if (dz) dz.close ? dz.close() : dz.removeAttribute('open'); return; }
      /* Klick auf den abgedunkelten Rand schließt */
      if (ev.target.matches && ev.target.matches('dialog[data-z-groesse]')) {
        var r = ev.target.getBoundingClientRect();
        if (ev.clientX < r.left || ev.clientX > r.right || ev.clientY < r.top || ev.clientY > r.bottom) ev.target.close();
      }
    });
  }

  /* ---------- 6. Bilder weich einblenden (4.0 „Bildwelt“) ---------- */
  function bilder() {
    var ziele = document.querySelectorAll('[data-z-bild], .sortiment-row');
    if (!ziele.length) return;
    function zeigen(el) { el.classList.add('z-bild-da'); }
    if (ruhig || !('IntersectionObserver' in window)) { Array.prototype.forEach.call(ziele, zeigen); return; }
    var b = new IntersectionObserver(function (e) {
      e.forEach(function (x) { if (x.isIntersecting) { zeigen(x.target); b.unobserve(x.target); } });
    }, { rootMargin: '0px 0px 25% 0px', threshold: 0 }); /* 4.7: früher einblenden */
    var h = window.innerHeight || 700;
    /* was beim Laden schon zu sehen ist, bleibt einfach stehen (kein Flackern) */
    Array.prototype.forEach.call(ziele, function (el) { if (el.getBoundingClientRect().top < h) zeigen(el); });
    /* Erst jetzt ausblenden: läuft dieses Skript nicht, bleiben alle Bilder sichtbar */
    document.documentElement.classList.add('z-bild-js');
    Array.prototype.forEach.call(ziele, function (el) { b.observe(el); });
  }

  function start() {
    [bilder, zuletzt, finder, punkteBeimWischen, groessen, einblenden].forEach(function (f) {
      try { f(); } catch (e) { if (window.console) console.warn('zinke-32', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
